import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

// 申请试用
export default {
  getUserModule(params) { //获取模块信息
    const url =  baseURL + '/tbUser/getUserModule';
    return axios.post(url, qs.stringify(params));
  },
  setUserModule(params) { //设置模块信息
    const url =  baseURL + '/tbUser/setUserModule';
    return axios.post(url, qs.stringify(params));
  },
  
}


// WEBPACK FOOTER //
// ./src/api/trial.js